import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { modal } from 'react-redux-modal';
import BroadcastToFacebookModal from '../Modals/BroadcastToFacebook';
import { sendTemplateRequest } from '../../actions/auth';

class BroadcastToFacebookButton extends Component {
  constructor(props) {
    super(props);
    this.broadcast = this.broadcast.bind(this);
  }
  broadcast = () => {
    modal.add(BroadcastToFacebookModal, {
      hideTitleBar: true,
      title: '',
      size: 'medium',
    });
  }

  componentWillMount() {
    const { fetchTemplate, currentLivecam } = this.props;
    fetchTemplate(currentLivecam);
  }

  componentWillUpdate(nextProps) {
    const { fetchTemplate, currentLivecam } = this.props;
    if (nextProps.currentLivecam !== currentLivecam) {
      fetchTemplate(nextProps.currentLivecam);
    }
  }

  render() {
    return (
      <button className="btn btn-facebook btn-block btn-sm-inline-block mx-1 mb-3 mb-md-0" onClick={this.broadcast}>
        Broadcast to Facebook
      </button>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    currentLivecam: state.currentItem.data.id,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchTemplate: id => dispatch(sendTemplateRequest(id)),
  };
};

BroadcastToFacebookButton.propTypes = {
  currentLivecam: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  fetchTemplate: PropTypes.func.isRequired,
};

BroadcastToFacebookButton.defaultProps = {
  currentLivecam: null,
};

export default connect(mapStateToProps, mapDispatchToProps)(BroadcastToFacebookButton);
